import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_H_C } from '../Layouts/index.js';
import { _className } from '../../utils/tools.js';
import './TS_Toggler.scss';
export class TS_Toggler extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const state = {};
        //First derive
        if (!this.state)
            state.value = this.props.defaultValue;
        else
            state.value = this.props.value || this.state.value;
        if (!state.value && nextProps.alwaysSelected)
            state.value = nextProps.options[0];
        state.disabled = nextProps.disabled;
        return state;
    }
    onValueChange = (value) => {
        const _value = value === this.state.value && !this.props.alwaysSelected ? undefined : value;
        this.props.onValueChange?.(_value);
        this.setState({ value: _value });
        this.reDeriveState();
    };
    cycleToggler = () => {
        const options = this.props.options;
        const currentOptionIndex = options.findIndex((value, index) => value === this.state.value);
        const nextValue = options.length - 1 > currentOptionIndex ? options[currentOptionIndex + 1]
            : this.props.alwaysSelected ? options[0]
                : undefined;
        this.onValueChange(nextValue);
    };
    renderButton = () => {
        let buttonDir = undefined;
        if (this.state.value === this.props.options[0])
            buttonDir = 'left';
        if (this.state.value === this.props.options[1])
            buttonDir = 'right';
        const buttonClassName = _className('ts-toggler__toggler-button', buttonDir);
        return _jsx("div", { className: 'ts-toggler__toggler', onClick: () => !this.props.disabled && this.cycleToggler(), children: _jsx("div", { className: buttonClassName }) });
    };
    renderOption = (option) => {
        const className = _className('ts-toggler__option', option === this.state?.value ? 'active' : undefined);
        return _jsx("span", { className: className, onClick: () => !this.props.disabled && this.onValueChange(option), children: option });
    };
    render() {
        const className = _className('ts-toggler', this.state.disabled ? 'disabled' : undefined);
        return _jsxs(LL_H_C, { className: className, children: [this.renderOption(this.props.options[0]), this.renderButton(), this.renderOption(this.props.options[1])] });
    }
}
//# sourceMappingURL=TS_Toggler.js.map